import React, { FC } from 'react';
import Icon from '@ant-design/icons';
import { IconProps } from 'ui/components/Icon';

const Export1SVG = () => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M15.2605 22.25H8.74047C3.83047 22.25 1.73047 20.15 1.73047 15.24V15.11C1.73047 10.67 3.48047 8.53003 7.40047 8.16003C7.80047 8.13003 8.18047 8.43003 8.22047 8.84003C8.26047 9.25003 7.96047 9.62003 7.54047 9.66003C4.40047 9.95003 3.23047 11.43 3.23047 15.12V15.25C3.23047 19.32 4.67047 20.76 8.74047 20.76H15.2605C19.3305 20.76 20.7705 19.32 20.7705 15.25V15.12C20.7705 11.41 19.5805 9.93003 16.3805 9.66003C15.9705 9.62003 15.6605 9.26003 15.7005 8.85003C15.7405 8.44003 16.0905 8.13003 16.5105 8.17003C20.4905 8.51003 22.2705 10.66 22.2705 15.13V15.26C22.2705 20.15 20.1705 22.25 15.2605 22.25Z'
      fill='currentColor'
    />
    <path
      d='M12 15.7501C11.59 15.7501 11.25 15.4101 11.25 15.0001V3.62012C11.25 3.21012 11.59 2.87012 12 2.87012C12.41 2.87012 12.75 3.21012 12.75 3.62012V15.0001C12.75 15.4101 12.41 15.7501 12 15.7501Z'
      fill='currentColor'
    />
    <path
      d='M15.3498 6.59994C15.1598 6.59994 14.9698 6.52994 14.8198 6.37994L11.9998 3.55994L9.17984 6.37994C8.88984 6.66994 8.40984 6.66994 8.11984 6.37994C7.82984 6.08994 7.82984 5.60994 8.11984 5.31994L11.4698 1.96994C11.7598 1.67994 12.2398 1.67994 12.5298 1.96994L15.8798 5.31994C16.1698 5.60994 16.1698 6.08994 15.8798 6.37994C15.7398 6.52994 15.5398 6.59994 15.3498 6.59994Z'
      fill='currentColor'
    />
  </svg>
);

export const Export1Outline: FC<IconProps> = props => <Icon component={Export1SVG} {...props} />;
